import { UPDATE_TOAST_ID } from '@/components/version-reload/constants';
import VersionReloadToast from '@/components/version-reload/VersionReloadToast';
import toast from 'react-hot-toast';

interface ShowVersionReloadToastOptions {
  countdownSeconds: number;
  isCountingDown: boolean;
  onLater: () => void;
  onRefresh: () => void;
}

export default function showVersionReloadToast({
  countdownSeconds,
  isCountingDown,
  onLater,
  onRefresh,
}: ShowVersionReloadToastOptions) {
  toast.custom(
    (t) => (
      <VersionReloadToast
        countdownSeconds={countdownSeconds}
        isCountingDown={isCountingDown}
        onLater={() => {
          onLater();
          toast.remove(t.id);
        }}
        onRefresh={onRefresh}
      />
    ),
    {
      id: UPDATE_TOAST_ID,
      duration: Infinity,
    },
  );
}
